import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import useDebounce from '../hooks/useDebounce';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilter } from '../actions/setFilters';

const SearchBar = (props) => {
    const reduxSearchTerm = useSelector((state) => state.filters.search);
    const [searchTerm, setSearchTerm] = useState(reduxSearchTerm);

    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateFilter('search', debouncedSearchTerm));
    }, [debouncedSearchTerm]);
    return (
        <TextField
            label="search this page"
            variant="outlined"
            style={{ marginBottom: '1rem', width: '100%' }}
            value={searchTerm}
            onChange={(e) => {
                setSearchTerm(e.target.value);
            }}
        />
    );
};

export default SearchBar;
